import classes from './salesPlanEdit.module.scss';
import SalesPlanEditForm from './components';

const SalesPlanEditScreen = () => {
  return (
    <div className={classes.salesPlanContainer}>
      <SalesPlanEditForm />
    </div>
  );
};

export default SalesPlanEditScreen;
